export const MODAL_KEYS = {
  appointmentScheduling: 'appointmentScheduling',
  xeroAuthConfirm: 'xeroAuthConfirm',
  documentUpload: 'documentUpload',
  paymentMethodAdd: 'paymentMethodAdd',
  statementDelete: 'statementDelete',
  transactionAdd: 'transactionAdd',
  transactionUpdate: 'transactionUpdate',
  transactionDelete: 'transactionDelete',
  taskResponseSend: 'taskResponseSend',
  bankAccountDelete: 'bankAccountDelete',
  chatMessageSearch: 'chatMessageSearch',
};
